import { h } from 'preact';
import { Component } from 'react';
import PropTypes from 'prop-types';

class PartsCard extends Component {
  render() {
    const {
      code,
      seal_list,
      badge,
      item_image,
      title,
      subtitle,
      item_offer,
      ctaButtonText,
    } = this.props;

    const seal_list_array = seal_list.length > 0 ? seal_list[0].split(',') : [];

    return (
      <div className="card parts-card">
        <div className="card__header">
          {badge && (
            <span className="card__badge badge badge--pill parts-card__badge">
              {seal_list_array[0]}
            </span>
          )}

          <a
            className="parts-card__link"
            href={`${this.props.part_link}/${this.props.slug}`}
          >
            {(item_image && item_image.middle_image && (
              <img
                className="parts-card__image"
                src={item_image.middle_image}
                alt={title}
                width="255"
                height="178"
              />
            )) || <div className="card__image-value" />}
          </a>
        </div>

        <div className="card__content parts-card__content">
          <div
            data-match-height="parts-card-content"
            className="parts-card-content-title"
          >
            <div className="card__title parts-card__title">{title}</div>
            <div className="card__subtitle parts-card__subtitle">
              {subtitle}
            </div>
          </div>
          <div
            className="parts-card-list"
            data-match-height="list-parts-card-list"
          >
            <ul className="card__list list parts-card__list">
              {code && (
                <li className="parts-card__list-item">Código: {code}</li>
              )}
              {seal_list_array[0] && (
                <li className="parts-card__list-item">{seal_list_array[0]}</li>
              )}
              {seal_list_array[1] && (
                <li className="parts-card__list-item">{seal_list_array[1]}</li>
              )}
            </ul>
          </div>
        </div>

        <div className="card__footer">
          <div
            data-match-height="parts-card-footer"
            className="card__box-part parts-card__prices"
          >
            {item_offer && item_offer.secondary_call && (
              <p className="card__trigger-starting-price">
                {item_offer.secondary_call}
              </p>
            )}
            {item_offer && item_offer.main_call && (
              <div className="card__trigger-main-price">
                {item_offer.main_call}
              </div>
            )}
            {item_offer && item_offer.featured && (
              <div className="card__trigger-value">{item_offer.featured}</div>
            )}
            {item_offer && item_offer.description && (
              <div className="card__trigger-description">
                {item_offer.description}
              </div>
            )}
            {item_offer && item_offer.extra && (
              <div className="card__trigger-description">
                {item_offer.extra}
              </div>
            )}
          </div>
          <a
            href={`${this.props.part_link}/${this.props.slug}`}
            className="btn button button--block button--large card__cta"
          >
            {ctaButtonText}
          </a>
        </div>
      </div>
    );
  }
}

PartsCard.defaultProps = {
  item_image: {},
  seal_list: [],
  class_modifier: '',
  ctaButtonText: 'Tenho interesse',
};

PartsCard.propTypes = {
  part_link: PropTypes.string,
  item_image: PropTypes.object,
  seal_list: PropTypes.array,
  class_modifier: PropTypes.string,
  ctaButtonText: PropTypes.string,
};

export default PartsCard;
